import React, { PureComponent } from 'react'
import PropTypes from 'prop-types'
import styled from 'styled-components'
import { Tooltip } from 'gipsy-ui'
import { styles, utils } from 'gipsy-misc'

const ReactionsContainer = styled.div`
  font-size: 12px;
  padding-top: 12px;
`

class InlineReactions extends PureComponent {
  static propTypes = {
    onChange: PropTypes.func.isRequired,
    reactions: PropTypes.array,
    sessionId: PropTypes.string,
    itemId: PropTypes.string
  }

  render() {
    const { reactions, sessionId, itemId, onChange } = this.props
    const grouped = groupByReaction(reactions)

    return (
      <ReactionsContainer>
        {Object.keys(grouped)
          .sort()
          .map(sign => {
            return (
              <InlineReaction
                key={sign}
                reactions={grouped[sign]}
                sign={sign}
                sessionId={sessionId}
                itemId={itemId}
                onChange={onChange}
              />
            )
          })}
      </ReactionsContainer>
    )
  }
}

export default InlineReactions

const groupByReaction = reactions => {
  let grouped = {}
  for (let r of reactions) {
    if (grouped[r.reaction]) {
      grouped[r.reaction].push(r)
    } else {
      grouped[r.reaction] = [r]
    }
  }
  return grouped
}

class InlineReaction extends PureComponent {
  static propTypes = {
    reactions: PropTypes.array,
    sign: PropTypes.string,
    sessionId: PropTypes.string,
    itemId: PropTypes.string
  }

  // This essentially calls this.props.onChange which will be defined only for relevant pages (TeamArchive and Teamlist)
  onClick = e => {
    e.stopPropagation()

    const { sign, sessionId, reactions } = this.props
    const isActive = this.isActive()
    if (isActive) {
      const myReactions = reactions.filter(r => r.from.userId === sessionId)
      if (!myReactions || myReactions.length === 0) {
        return
      }
      const data = { paramName: 'reactions', value: reactions[0], method: 'remove' }
      this.props.onChange(data)
    } else {
      const data = { paramName: 'reactions', value: { reaction: sign }, method: 'add' }
      this.props.onChange(data)
    }
  }

  isActive = () => {
    const { reactions, sign, sessionId } = this.props
    return !!reactions.find(r => r.reaction === sign && r.from.userId === sessionId)
  }

  render() {
    const { reactions, sign } = this.props
    if (!reactions) {
      return
    }
    const count = reactions.length
    const isActive = this.isActive()

    return (
      <ReactionContainer key={sign} isActive={isActive} onClick={this.onClick}>
        {sign}
        {count}
        <Tooltip text={utils.reactions.makeTooltipText(reactions)} vs={25} hs={18} position="bottom right" />
      </ReactionContainer>
    )
  }
}

const ReactionContainer = styled.div`
  position: relative;
  display: inline;
  border-width: 1px;
  border-radius: 8px;
  border-style: solid;
  border-color: ${props => (props.isActive ? styles.colors.greenColor : styles.colors.borderColor)};
  background-color: ${props => (props.isActive ? styles.colors.greenLightColor : '')};
  padding: 3px;
  margin: 1px;
  &:hover {
    border-color: ${styles.colors.borderColorFocus};
  }
`



// WEBPACK FOOTER //
// ./src/features/list/components/line/components/InlineReactions.js